import { getNameWithoutExt } from '../../../helpers/attachments/getNameWithoutExt';

export const getAttachmentName = ({ name, fileName }) => {
  const normalizedName = name?.trim();

  if (normalizedName) {
    return normalizedName;
  }

  return getNameWithoutExt(fileName);
};

const normalizeExtension = (extension = '') => {
  if (!extension) {
    return '';
  }

  return extension.startsWith('.') ? extension : `.${extension}`;
};

export const createNameWithExtension = (attachment) => {
  if (!attachment) {
    return '';
  }

  const { name = '', extension = '', fileName } = attachment;

  if (!name) {
    return fileName ?? '';
  }

  const normalizedExtension = normalizeExtension(extension);

  if (!normalizedExtension) {
    return name;
  }

  return name.toLowerCase().endsWith(normalizedExtension.toLowerCase())
    ? name
    : `${name}${normalizedExtension}`;
};
